import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import PrivilegesSections from '../../../Admin/Roles/PrivilegesSections';
import useReadOnlyPrivileges from '../../../../hooks/features/privileges/useReadOnlyPrivileges';
import { capitalizeFirstLetter } from '../../../utils/stringUtils';
import ProfileFieldDisplay from '../sections/ProfileFieldDisplay';
import styles from '../Profile.module.css';

const EMPTY_FORMIK_VALUES = {};
const DISABLED_HANDLER = () => {};

const ReadOnlyPrivilegesView = ({
  roleName,
  rawPrivileges,
  hasCustomPrivileges,
}) => {
  const { t } = useTranslation();
  const privilegesData = useReadOnlyPrivileges(rawPrivileges);

  return (
    <>
      <div className={styles.divider} />
      <ProfileFieldDisplay
        label={t('Role')}
        value={roleName || t('profileData.noRoleAssigned')}
      />
      {hasCustomPrivileges && (
        <div className={styles.customPrivilegesWarning}>
          {t('privilegesSection.customPrivilegesWarning')}
        </div>
      )}
      {privilegesData && (
        <Formik initialValues={EMPTY_FORMIK_VALUES} enableReinitialize>
          <Form>
            <PrivilegesSections
              sections={privilegesData.sections}
              isSectionSelected={privilegesData.isSectionSelected}
              published={false}
              privileges={privilegesData.privileges}
              boxesState={privilegesData.boxesState}
              handleSectionClearAll={DISABLED_HANDLER}
              handleSectionSelection={DISABLED_HANDLER}
              handleCheckboxChange={DISABLED_HANDLER}
              capitalizeFirstLetter={capitalizeFirstLetter}
              selectedPrivileges={privilegesData.selectedPrivileges}
              handleSelectAll={DISABLED_HANDLER}
              readOnly
            />
          </Form>
        </Formik>
      )}
    </>
  );
};

export default ReadOnlyPrivilegesView;
